/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GroupJoinInput,
  GroupJoinResult,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Join a group with token
 */
export const joinGroup = (
    groupJoinInput: MaybeRefOrGetter<GroupJoinInput>,
 signal?: AbortSignal
) => {
      groupJoinInput = toValue(groupJoinInput);

      return axiosClient<GroupJoinResult>(
      {url: `/b2b/group_joins`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupJoinInput, signal
    },
      );
    }




export const getJoinGroupMutationKey = () => ['joinGroup'] as const;

export const getJoinGroupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinGroup>>, TError,JoinGroupMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof joinGroup>>, TError,JoinGroupMutationVariables, TContext> => {

const mutationKey = getJoinGroupMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinGroup>>, JoinGroupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  joinGroup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinGroupMutationResult = NonNullable<Awaited<ReturnType<typeof joinGroup>>>
    export type JoinGroupMutationBody = GroupJoinInput
    export type JoinGroupMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type JoinGroupMutationVariables = {data: GroupJoinInput}

    /**
 * @summary Join a group with token
 */
export const useJoinGroup = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinGroup>>, TError,JoinGroupMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof joinGroup>>,
        TError,
        JoinGroupMutationVariables,
        TContext
      > => {
      return useMutation(getJoinGroupMutationOptions(options), queryClient);
    }
